<template>
  <v-container fluid>
    <v-layout wrap>
      <v-flex xs6>
        <v-btn color="primary" @click="loadTeachers()">refresh</v-btn>
      </v-flex>
      <v-flex xs6>
        <v-select v-model="period" :items="periods" item-text="title" item-value="id" />
      </v-flex>
      <v-flex xs12>
        <v-data-table :headers="headers" :items="teachers" :hide-actions="false" item-key="id" :loading="loading" :total-items="total" :pagination.sync="pagination" no-data-text="Список преподавателей пуст">
          <template v-slot:items="{ item: teacher }">
            <td>{{ teacher.lastname }} {{ teacher.firstname }} {{ teacher.patronymic }}</td>
            <td>
              <v-chip>{{ teacher.username }}</v-chip>
            </td>
            <td>{{ ( teacher.department && teacher.department.title) ? teacher.department.title[locale] : '' }}</td>
            <td>
              <v-icon v-if="teacher.is_head">check</v-icon>
            </td>
            <td class="text-xs-right layout">
              <v-btn flat icon title="Редактировать" color="primary">
                <v-icon>edit</v-icon>
              </v-btn>
              <v-btn flat icon title="Удалить" color="error">
                <v-icon>delete</v-icon>
              </v-btn>
            </td>
          </template>
        </v-data-table>
      </v-flex>
    </v-layout>
    <v-layout mt-3>
      <v-flex xs12 text-xs-right>
        <v-dialog v-model="teacherForm.dialog" persistent max-width="600">
          <template v-slot:activator="{ on }">
            <v-btn color="info" v-on="on">Добавить</v-btn>
          </template>
          <v-card>
            <v-card-title>
              <span class="headline">Новый сотрудник</span>
            </v-card-title>
            <v-card-text>
              <v-form v-model="teacherForm.valid" ref="teacherForm">
                <v-container grid-list-md>
                  <v-layout wrap>
                    <v-flex xs12>
                      <v-select label="Кафедра" required v-model="teacherForm.values.department.code" :items="departments" item-value="code" item-text="title" :rules="teacherForm.rules.department"></v-select>
                    </v-flex>
                    <v-flex xs12>
                      <v-text-field label="Фамилия" required v-model="teacherForm.values.lastname" :counter="50" :rules="teacherForm.rules.lastname" />
                    </v-flex>
                    <v-flex xs12>
                      <v-text-field label="Имя" required v-model="teacherForm.values.firstname" :counter="50" :rules="teacherForm.rules.firstname" />
                    </v-flex>
                    <v-flex xs12>
                      <v-text-field label="Отчество" required v-model="teacherForm.values.patronymic" :counter="50" :rules="teacherForm.rules.patronymic" />
                    </v-flex>
                  </v-layout>
                </v-container>
              </v-form>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="red darken-1" flat @click="teacherFormClose">Отмена</v-btn>
              <v-btn color="blue darken-1" flat @click="teacherFormSave" :loading="teacherForm.saving">Сохранить</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import { mapState } from 'vuex'

export default {
  data: () => ({
    limit: 5,
    pagination: {},
    loading: false,

    period: '2020-2021',

    teacherForm: {
      dialog: false,
      valid: false,
      saving: false,
      values: {
        id: '',
        lastname: '',
        firstname: '',
        patronymic: '',
        username: '',
        department: {
          code: '',
          title: ''
        }
      },
      rules: {
        code: [
          v => !!v || 'Обязательное поле',
          v => (v && v.length <= 20) || 'Максимум 20 символов'
        ],
        department: [
          v => !!v || 'Необходимо указать институт'
        ],
        lastname: [
          v => !!v || 'Обязательное поле',
          v => (v && v.length <= 50) || 'Максимум 50 символов'
        ],
        firstname: [
          v => !!v || 'Обязательное поле',
          v => (v && v.length <= 50) || 'Максимум 50 символов'
        ],
        patronymic: [
          v => (v && v.length <= 50) || 'Максимум 50 символов'
        ]
      }
    },
    headers: [
      {
        text: 'ФИО',
        align: 'left',
        sortable: true,
        value: 'fullname'
      },
      {
        text: 'Логин',
        align: 'left',
        sortable: true,
        value: 'username'
      },
      {
        text: 'Кафедра',
        align: 'left',
        sortable: true,
        value: 'department.title'
      },
      {
        text: 'Заведующий',
        align: 'left',
        sortable: true,
        value: 'is_head'
      },
      {
        text: '',
        sortable: false,
        value: null
      }
    ]
  }),
  computed: {
    locale () {
      return this.$i18n.locale
    },
    periods () {
      return Object.values(this.$store.getters["periods/periods"])
    },
    ...mapState('departments', {
      departments: (state) => {
        return Object.values(state.departments).sort((a, b) => {
          if (a.title < b.title) return -1
          if (a.title > b.title) return 1
          return 0
        })
      }
    }),
    ...mapState('teachers', {
      teachers: (state) => {
        return state.teachers
      },
      total: (state) => {
        return state.total
      }
    }),
    userManagerRole () {
      return this.$store.getters.managerRole
    },
  },
  watch: {
    pagination: {
      handler () {
        this.limit = this.pagination.rowsPerPage
        this.loadTeachers(this.limit * (this.pagination.page - 1))
      },
      deep: true
    }
  },
  mounted () {
    this.loadPeriods();
    this.loadTeachers(0)
    this.loadDepartments()
  },
  methods: {
    async loadPeriods () {
      await this.$store.dispatch("periods/getPeriods")
    },
    loadTeachers (offset, limit) {
      this.loading = true

      let role = this.userManagerRole ?? 'manager'
      let period = this.period

      limit = limit || this.limit
      this.$store.dispatch('teachers/getTeachers', {offset, limit, role, period}).catch((error) => {
        // eslint-disable-next-line
        console.error(error)
      }).finally(() => {
        this.loading = false
      })
    },
    loadDepartments () {
      this.$store.dispatch('departments/getDepartments').catch((error) => {
        // eslint-disable-next-line
        console.error(error)
      })
    },

    teacherFormOpen (teacher) {
      this.teacherForm.values = teacher
      this.teacherForm.dialog = true
    },
    teacherFormClose () {
      this.teacherForm.dialog = false
      this.$refs.teacherForm.reset()
    },
    teacherFormSave () {
      if (this.$refs.teacherForm.validate()) {
        this.teacherForm.saving = true
        this.$store.dispatch('teachers/saveTeacher', this.teacherForm.values).then(() => {
          this.$events.$emit('notify', {
            message: 'Преподаватель успешно добавлен',
            type: 'info'
          })
        }).catch((error) => {
          // eslint-disable-next-line
          console.error(error)
        }).finally(() => {
          this.teacherForm.saving = false
          this.teacherFormClose()
        })
      }
    }
  }
}
</script>
